import { Route, Routes, useParams } from 'react-router-dom';
import { QesoEditRoutes } from './Edit';

export const QesoProgramRoutes = () => {
  const { warrantProgramId } = useParams<{ warrantProgramId: string }>();

  return (
    <Routes>
      <Route path="edit" element={<QesoEditRoutes warrantProgramId={warrantProgramId!} />}>
        <Route path="*" element={<QesoEditRoutes warrantProgramId={warrantProgramId!} />} />
      </Route>
    </Routes>
  );
};
